import { space } from './tokens';

/**
 * Layout constants shared by the admin chrome (AdminLayout), its panel toggle,
 * and pages that lay panels out beside the IQ Panel (the Batch screen). Kept
 * out of the component files so editing those still hot-reloads.
 */

/**
 * Header height. Set explicitly on the Header rather than left to antd's
 * default, so a page that sizes itself against it (the Batch screen's
 * full-height layout) has one source of truth.
 */
export const ADMIN_HEADER_HEIGHT = 64;

/**
 * Padding around every routed page. A page whose panels must run edge to edge
 * — the Batch screen, where the event rail sits flush against the IQ Panel —
 * cancels it with a matching negative margin.
 */
export const ADMIN_CONTENT_PADDING = space.xl;

/**
 * The same padding on a phone-width viewport (see `useNarrowViewport`), where
 * 24px a side would spend an eighth of the screen on margins.
 */
export const ADMIN_CONTENT_PADDING_NARROW = space.md;

/**
 * Width of every collapsed side panel — the IQ Panel and the Batch event rail —
 * and the size of the square each panel's toggle is anchored in.
 *
 * Those two being the same number is what keeps a toggle still: it sits in the
 * leftmost column of its panel, which is exactly the part left visible when the
 * panel collapses, so the panel opens and closes around it.
 */
export const PANEL_COLLAPSED_WIDTH = 48;

/** One duration for every panel collapse, so both panels move identically. */
export const PANEL_TRANSITION_MS = 250;
